import React from 'react';

import { Box } from '@material-ui/core';
import cx from 'classnames';

import IKImage from '../../../../components/IKImage/IKImage';
import { Loader } from '../../../../components/Loader';
import { MathJaxBlock } from '../../../../components/MathJaxBlock';
import { BREAKPOINTS_VALUES } from '../../../../theme';
import { useMathJaxScriptLoader } from '../../../../utils/hooks';
import { PAYWALLED_CONTENT_SELECTORS } from '../../const';
import useStyles from './styles';

const BLOCKS = [
  {
    layout: 'image',
    Component: (data) => {
      const classes = useStyles();
      return (
        <Box className={classes.imageWrapper}>
          <IKImage
            path={data.data.image}
            alt={data.data.alt}
            draggable={false}
            srcset={[{ width: 400 }, { width: 700 }, { width: 800 }, { width: 900 }]}
            sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 400px, (max-width:${BREAKPOINTS_VALUES['md']}px) 700px, (max-width:${BREAKPOINTS_VALUES['lg']}px) 800px, 900px`}
          />
        </Box>
      );
    },
  },
  {
    layout: 'html',
    Component: (data) => {
      return (
        <MathJaxBlock>
          <div dangerouslySetInnerHTML={{ __html: data?.data?.html }} />
        </MathJaxBlock>
      );
    },
  },
];

interface SummaryProps {
  summary?: string | null;
  wrapperClass?: string | null;
}

const Summary: React.FC<SummaryProps> = ({ summary, wrapperClass = '' }) => {
  const classes = useStyles();
  const isMathJaxLoaded = useMathJaxScriptLoader();

  if (!isMathJaxLoaded) {
    return (
      <Box className={classes.summaryLoaderWrapper}>
        <Loader global={false} data-testid="summary-loader" />
      </Box>
    );
  }

  const summaryContent = summary && JSON.parse(summary);

  return (
    <Box
      className={cx(
        classes.tabText,
        PAYWALLED_CONTENT_SELECTORS.SUMMARY,
        wrapperClass,
        'wrapperWithStyledTable',
      )}
      data-testid="videoSummary"
    >
      {summaryContent &&
        Array.isArray(summaryContent) &&
        summaryContent.map((block) => {
          const desiredBlock = BLOCKS.find((item) => item.layout === block.layout);
          const Component: (({ data }: { data: any }) => JSX.Element | null) | undefined =
            desiredBlock?.Component;

          if (!Component) return null;
          return <Component key={block.key} data={block.attributes} />;
        })}
      {summaryContent && typeof summaryContent === 'string' && (
        <MathJaxBlock>
          <div dangerouslySetInnerHTML={{ __html: summaryContent }} />
        </MathJaxBlock>
      )}
    </Box>
  );
};

export default Summary;
